import { typography } from '@dentalux/ui-library-core/themes'

import { Components, Theme } from '@mui/material'

const MuiCssBaseline: Components<Theme>['MuiCssBaseline'] = {
  styleOverrides: {
    html: {
      backgroundColor: 'grey.100',
    },
    body: {
      ...typography['Sarabun Body 1'],
      color: 'grey.800',
    },
    a: {
      color: 'primary.800',
    },
  },
}

export default MuiCssBaseline
